interface Term {
  term: string;
  slug: string;
  definition: string;
  extendedDescription?: string;
  category: string;
  relatedTerms?: { term: string; slug: string }[];
}

export const allTerms: Term[] = [
  {
    term: "Aanraakspanning",
    slug: "aanraakspanning",
    definition:
      "De spanning die kan ontstaan tussen geleidende delen wanneer deze gelijktijdig worden aangeraakt.",
    extendedDescription:
      "Aanraakspanning is een belangrijk veiligheidsconcept in de elektrotechniek. Het gaat om de spanning die iemand kan ervaren bij het aanraken van een elektrische installatie. De maximaal toegestane aanraakspanning is vastgelegd in veiligheidsnormen om elektrische schokken te voorkomen.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardlekschakelaar", slug: "aardlekschakelaar" },
    ],
  },
  {
    term: "Aarding",
    slug: "aarding",
    definition: "Een verbinding met de aarde voor elektrische veiligheid.",
    extendedDescription:
      "Aarding is een essentieel onderdeel van elke elektrische installatie. Het zorgt ervoor dat bij een storing of kortsluiting de stroom veilig wordt afgevoerd naar de aarde, waardoor het risico op elektrische schokken wordt geminimaliseerd.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aardpen", slug: "aardpen" },
      { term: "Aardedraad", slug: "aardedraad" },
      { term: "Aarderail", slug: "aarderail" },
    ],
  },
  {
    term: "Aardpen",
    slug: "aardpen",
    definition:
      "Een metalen staaf die in de grond wordt geslagen voor het maken van een aardverbinding.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardedraad", slug: "aardedraad" },
    ],
  },
  {
    term: "Aardedraad",
    slug: "aardedraad",
    definition: "De draad die zorgt voor de verbinding met de aarde.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aarderail", slug: "aarderail" },
    ],
  },
  {
    term: "Aarderail",
    slug: "aarderail",
    definition:
      "Een koperen rail in de meterkast waar alle aarddraden samenkomen.",
    category: "Installatie",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardedraad", slug: "aardedraad" },
    ],
  },
  {
    term: "Aardlekschakelaar",
    slug: "aardlekschakelaar",
    definition:
      "Een veiligheidsschakelaar die de stroom uitschakelt bij een lekstroom naar de aarde.",
    extendedDescription:
      "Een aardlekschakelaar is verplicht in moderne elektrische installaties en detecteert stroomverlies. Als er een lekstroom wordt gedetecteerd, schakelt de aardlekschakelaar het circuit direct uit om elektrische schokken te voorkomen.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aarding", slug: "aarding" },
      { term: "Aardlekautomaat", slug: "aardlekautomaat" },
    ],
  },
  {
    term: "Aardlekautomaat",
    slug: "aardlekautomaat",
    definition:
      "Een combinatie van een aardlekschakelaar en een installatieautomaat.",
    extendedDescription:
      "Een aardlekautomaat biedt zowel bescherming tegen lekstromen als tegen overbelasting en kortsluiting. Dit maakt het een efficiënte en ruimtebesparende oplossing in groepenkasten.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Aardlekschakelaar", slug: "aardlekschakelaar" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "Installatieautomaat",
    slug: "installatieautomaat",
    definition:
      "Een zekering die automatisch uitschakelt bij overbelasting of kortsluiting.",
    extendedDescription:
      "Een installatieautomaat wordt gebruikt om elektrische circuits te beschermen. In tegenstelling tot smeltzekeringen hoeft een installatieautomaat niet vervangen te worden na een uitschakeling, maar kan deze eenvoudig worden gereset.",
    category: "Installatie",
    relatedTerms: [
      { term: "Aardlekautomaat", slug: "aardlekautomaat" },
      { term: "Groepenkast", slug: "groepenkast" },
    ],
  },
  {
    term: "Groepenkast",
    slug: "groepenkast",
    definition: "Het verdeelpunt van de elektrische installatie in een gebouw.",
    extendedDescription:
      "De groepenkast bevat installatieautomaten, aardlekschakelaars en andere beveiligingscomponenten. Het is het centrale punt waar elektriciteit wordt verdeeld over de verschillende groepen binnen een gebouw.",
    category: "Installatie",
    relatedTerms: [
      { term: "Aardlekschakelaar", slug: "aardlekschakelaar" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "B16",
    slug: "b16",
    definition: "Een installatieautomaat van 16 ampère met B-karakteristiek.",
    extendedDescription:
      "De B16-automaat is een veelgebruikte installatieautomaat in huishoudelijke installaties. Hij schakelt uit bij overbelasting en kortsluiting en is geschikt voor standaard elektrische apparaten en verlichting.",
    category: "Installatie",
    relatedTerms: [
      { term: "Installatieautomaat", slug: "installatieautomaat" },
      { term: "Groepenkast", slug: "groepenkast" },
    ],
  },
  {
    term: "Beltrafo",
    slug: "beltrafo",
    definition: "Een transformator voor deurbellen.",
    extendedDescription:
      "Een beltransformator verlaagt de netspanning naar een veilige spanning (meestal 8V, 12V of 24V) voor deurbelinstallaties. Hij wordt vaak in de groepenkast gemonteerd.",
    category: "Installatie",
    relatedTerms: [
      { term: "Transformator", slug: "transformator" },
      { term: "Groepenkast", slug: "groepenkast" },
    ],
  },
  {
    term: "CAT6",
    slug: "cat6",
    definition: "Een categorie netwerkkabel voor dataverkeer.",
    extendedDescription:
      "CAT6-kabels ondersteunen netwerksnelheden tot 10 Gbps op korte afstanden en hebben een betere signaalkwaliteit dan oudere categorieën zoals CAT5e.",
    category: "Netwerkinstallatie",
    relatedTerms: [
      { term: "CAT7", slug: "cat7" },
      { term: "RJ45", slug: "rj45" },
    ],
  },
  {
    term: "CAT7",
    slug: "cat7",
    definition: "Een verbeterde categorie netwerkkabel voor dataverkeer.",
    extendedDescription:
      "CAT7-kabels bieden betere afscherming en hogere bandbreedtes dan CAT6, waardoor ze geschikt zijn voor high-performance netwerken en serveromgevingen.",
    category: "Netwerkinstallatie",
    relatedTerms: [
      { term: "CAT6", slug: "cat6" },
      { term: "RJ45", slug: "rj45" },
    ],
  },
  {
    term: "Aansluitschema",
    slug: "aansluitschema",
    definition:
      "Een diagram dat de aansluitingen van een elektrisch systeem weergeeft.",
    category: "Installatie",
  },
  {
    term: "Aansluitwaarde",
    slug: "aansluitwaarde",
    definition:
      "De maximale belasting die een elektrische installatie kan dragen.",
    category: "Installatie",
  },
  {
    term: "Aantal module",
    slug: "aantal-module",
    definition:
      "Het aantal zonnepanelen of andere modules die in een installatie worden gebruikt.",
    category: "Zonnepanelen",
  },
  {
    term: "ABB",
    slug: "abb",
    definition:
      "Een internationaal bedrijf dat producten en systemen voor elektrische en elektronische installaties levert.",
    category: "Installatie",
  },
  {
    term: "AC (wisselstroom)",
    slug: "ac-wisselstroom",
    definition: "Elektrische stroom die periodiek van richting verandert.",
    category: "Basisbegrippen",
  },
  {
    term: "Adereindhulzen",
    slug: "adereindhulzen",
    definition:
      "Beschermende hulsjes die worden gebruikt om de uiteinden van elektrische draden te isoleren.",
    category: "Installatie",
  },
  {
    term: "Afdekplaat",
    slug: "afdekplaat",
    definition:
      "Een plaat die wordt gebruikt om een opening in een elektrisch apparaat of installatie af te dekken.",
    category: "Installatie",
  },
  {
    term: "Afdekraam",
    slug: "afdekraam",
    definition:
      "Een raam dat wordt gebruikt om schakelaars en stopcontacten te omkaderen en af te dekken.",
    category: "Installatie",
  },
  {
    term: "Afmonteren",
    slug: "afmonteren",
    definition:
      "Het laatste gedeelte van een installatie waarbij de apparatuur wordt gemonteerd en aangesloten.",
    category: "Installatie",
  },
  {
    term: "Armaturen",
    slug: "armaturen",
    definition:
      "Verlichtingstoestellen die zijn ontworpen voor elektrische verlichting in gebouwen en buitenruimtes.",
    category: "Installatie",
  },
  {
    term: "Attema",
    slug: "attema",
    definition:
      "Een merk dat producten levert voor de elektrotechnische en installatiebranche.",
    category: "Installatie",
  },
  {
    term: "Beugels",
    slug: "beugels",
    definition:
      "Hulpmiddelen die worden gebruikt voor het bevestigen van leidingen, kabels of andere installaties.",
    category: "Installatie",
  },
  {
    term: "Bewegingssensor",
    slug: "bewegingssensor",
    definition:
      "Een sensor die beweging detecteert en automatisch apparaten zoals verlichting inschakelt.",
    category: "Installatie",
  },
  {
    term: "Bliksemafleider",
    slug: "bliksemafleider",
    definition:
      "Een systeem dat is ontworpen om de gevolgen van blikseminslagen te verminderen door de energie naar de grond af te voeren.",
    category: "Veiligheid",
  },
  {
    term: "Bouwtekening",
    slug: "bouwtekening",
    definition:
      "Een gedetailleerde tekening van de bouwstructuur, inclusief elektrische installaties.",
    category: "Installatie",
  },
  {
    term: "Buitenverlichting",
    slug: "buitenverlichting",
    definition:
      "Verlichting die buiten een gebouw wordt geïnstalleerd, zoals tuinlampen en gevelverlichting.",
    category: "Installatie",
  },
  {
    term: "CAI",
    slug: "cai",
    definition: "Aansluitsysteem voor kabeltelevisie, radio en internet.",
    category: "Netwerkinstallatie",
  },
  {
    term: "CEE",
    slug: "cee",
    definition:
      "Een type stopcontact en stekker voor zware apparaten, vaak gebruikt in industriële omgevingen.",
    category: "Installatie",
  },
  {
    term: "Centraaldoos",
    slug: "centraaldoos",
    definition:
      "Een doos die wordt gebruikt om verschillende elektrische verbindingen centraal te verbinden.",
    category: "Installatie",
  },
  {
    term: "Circuitonderbreker",
    slug: "circuitonderbreker",
    definition:
      "Een automatisch inschakelapparaat dat de stroom onderbreekt bij een kortsluiting of overbelasting.",
    category: "Installatie",
  },
  {
    term: "Coax",
    slug: "coax",
    definition:
      "Een type kabel die wordt gebruikt voor het transporteren van signaal voor televisie en data.",
    category: "Netwerkinstallatie",
  },
  {
    term: "Combinatieschakeling",
    slug: "combinatieschakeling",
    definition:
      "Een schakeling waarbij meerdere componenten zoals lampen en schakelaars in combinatie werken.",
    category: "Installatie",
  },
  {
    term: "Connector",
    slug: "connector",
    definition:
      "Een mechanisch element dat twee elektrische geleiders verbindt.",
    category: "Installatie",
  },
  {
    term: "Coulomb",
    slug: "coulomb",
    definition: "De eenheid van elektrische lading in het SI-stelsel.",
    category: "Basisbegrippen",
  },
  {
    term: "Data",
    slug: "data",
    definition: "Informatie die digitaal kan worden opgeslagen en verwerkt.",
    category: "Netwerkinstallatie",
  },
  {
    term: "DC (gelijkstroom)",
    slug: "dc-gelijkstroom",
    definition: "Elektrische stroom die altijd in dezelfde richting vloeit.",
    category: "Basisbegrippen",
  },
  {
    term: "Demontage",
    slug: "demontage",
    definition:
      "Het proces van het verwijderen of afbreken van een installatie of apparatuur.",
    category: "Installatie",
  },
  {
    term: "Dimfunctie",
    slug: "dimfunctie",
    definition:
      "De mogelijkheid om de helderheid van een lamp of lichtbron te regelen.",
    category: "Installatie",
  },
  {
    term: "Dimmer",
    slug: "dimmer",
    definition:
      "Een apparaat dat wordt gebruikt om de helderheid van verlichting te regelen.",
    category: "Installatie",
  },
  {
    term: "DIN-rail",
    slug: "din-rail",
    definition:
      "Een type rail die in elektrische kasten wordt gebruikt om apparaten en componenten te monteren.",
    category: "Installatie",
  },
  {
    term: "Domotica",
    slug: "domotica",
    definition:
      "Slimme huistechnologie die gebruikt wordt voor het automatiseren van woningfuncties.",
    category: "Installatie",
  },
  {
    term: "Doorlaatwaarde",
    slug: "doorlaatwaarde",
    definition:
      "De maximale hoeveelheid stroom die door een kabel of apparaat kan stromen zonder schade.",
    category: "Basisbegrippen",
  },
  {
    term: "Dozenboor",
    slug: "dozenboor",
    definition:
      "Een boor die wordt gebruikt om gaten te maken voor het plaatsen van inbouwdozen in muren.",
    category: "Installatie",
  },
  {
    term: "Draadgoot",
    slug: "draadgoot",
    definition:
      "Een goot die wordt gebruikt om elektrische kabels op een veilige manier te geleiden.",
    category: "Installatie",
  },
  {
    term: "Duspol",
    slug: "duspol",
    definition:
      "Een soort spanningzoeker die wordt gebruikt om te controleren of er spanning op een kabel staat.",
    category: "Installatie",
  },
  {
    term: "Duurzaam",
    slug: "duurzaam",
    definition:
      "Een benadering waarbij rekening wordt gehouden met milieuvriendelijkheid en lange-termijn effecten.",
    category: "Duurzaamheid",
  },
  {
    term: "Eaton",
    slug: "eaton",
    definition: "Een wereldwijd bedrijf dat energiebeheeroplossingen biedt.",
    category: "Installatie",
  },
  {
    term: "Elektricien",
    slug: "elektricien",
    definition:
      "Een vakman die gespecialiseerd is in elektrische installaties en onderhoud.",
    category: "Installatie",
  },
  {
    term: "Elektrode",
    slug: "elektrode",
    definition:
      "Een geleider die wordt gebruikt om stroom in of uit een elektrisch medium te sturen.",
    category: "Installatie",
  },
  {
    term: "Energie",
    slug: "energie",
    definition:
      "De capaciteit om arbeid te verrichten, bijvoorbeeld in de vorm van elektriciteit.",
    category: "Basisbegrippen",
  },
  {
    term: "Energie rekening",
    slug: "energie-rekening",
    definition:
      "Een periodieke factuur die het energieverbruik van een gebouw of huishouden toont.",
    category: "Duurzaamheid",
  },
  {
    term: "Externe groepenkast",
    slug: "externe-groepenkast",
    definition:
      "Een groepenkast die buiten een gebouw wordt geïnstalleerd, bijvoorbeeld in een tuin of op een fabrieksterrein.",
    category: "Installatie",
  },
  {
    term: "Fase",
    slug: "fase",
    definition:
      "Een fase in een elektrisch systeem is een geleider die de elektrische stroom van het ene punt naar een ander punt transporteert.",
    category: "Installatie",
    relatedTerms: [
      { term: "Faseleiding", slug: "faseleiding" },
      { term: "Fasenspanning", slug: "fasenspanning" },
    ],
  },
  {
    term: "Faseleiding",
    slug: "faseleiding",
    definition:
      "Een elektrische draad die een specifieke fase van een elektrisch systeem verbindt.",
    category: "Installatie",
    relatedTerms: [
      { term: "Fase", slug: "fase" },
      { term: "Neutraler", slug: "neutraler" },
    ],
  },
  {
    term: "Fasenspanning",
    slug: "fasenspanning",
    definition:
      "De spanning die bestaat tussen twee fasen in een driefasig systeem.",
    category: "Basisbegrippen",
    relatedTerms: [
      { term: "Fase", slug: "fase" },
      { term: "Driefase", slug: "driefase" },
    ],
  },
  {
    term: "Driefase",
    slug: "driefase",
    definition:
      "Een elektrisch systeem waarbij drie fasen van elektrische stroom worden gebruikt, wat zorgt voor een stabiele en efficiënte energieoverdracht.",
    extendedDescription:
      "Driefasige systemen worden veel gebruikt in industriële en commerciële toepassingen voor het aandrijven van zware machines en apparaten. Dit systeem biedt een constante stroom van energie, wat resulteert in een gelijkmatiger gebruik van de elektrische capaciteit.",
    category: "Installatie",
    relatedTerms: [
      { term: "Fasenspanning", slug: "fasenspanning" },
      { term: "Fase", slug: "fase" },
    ],
  },
  {
    term: "Generator",
    slug: "generator",
    definition:
      "Een apparaat dat mechanische energie omzet in elektrische energie.",
    category: "Installatie",
    relatedTerms: [
      { term: "Alternator", slug: "alternator" },
      { term: "Stroom", slug: "stroom" },
    ],
  },
  {
    term: "Gelijkrichter",
    slug: "gelijkrichter",
    definition:
      "Een apparaat dat wisselstroom (AC) omzet naar gelijkstroom (DC).",
    category: "Installatie",
    relatedTerms: [
      { term: "Transformator", slug: "transformator" },
      { term: "Rectificatie", slug: "rectificatie" },
    ],
  },
  {
    term: "Transformator",
    slug: "transformator",
    definition:
      "Een apparaat dat de spanning van wisselstroom verhoogt of verlaagt.",
    category: "Installatie",
    relatedTerms: [
      { term: "Gelijkrichter", slug: "gelijkrichter" },
      { term: "Stroom", slug: "stroom" },
    ],
  },
  {
    term: "Kortsluiting",
    slug: "kortsluiting",
    definition:
      "Een ongewenste verbinding tussen twee geleiders die leidt tot een te grote stroom.",
    extendedDescription:
      "Kortsluitingen kunnen leiden tot beschadiging van elektrische apparatuur en zijn gevaarlijk vanwege de verhoogde kans op brand en elektrische schokken.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Zekering", slug: "zekering" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "Zekering",
    slug: "zekering",
    definition:
      "Een beschermingscomponent die de stroom in een elektrisch circuit onderbreekt bij een te hoge stroom.",
    extendedDescription:
      "Zekeringen worden gebruikt om te voorkomen dat een elektrische installatie beschadigd raakt door overbelasting. Ze zijn ontworpen om te doorbranden bij een stroom die de veilige waarde overschrijdt.",
    category: "Veiligheid",
    relatedTerms: [
      { term: "Kortsluiting", slug: "kortsluiting" },
      { term: "Installatieautomaat", slug: "installatieautomaat" },
    ],
  },
  {
    term: "Kabelgoot",
    slug: "kabelgoot",
    definition:
      "Een goot die wordt gebruikt voor het veilig en overzichtelijk geleiden van kabels in een gebouw.",
    category: "Installatie",
    relatedTerms: [
      { term: "Draadgoot", slug: "draadgoot" },
      { term: "Kabel", slug: "kabel" },
    ],
  },
  {
    term: "Kabel",
    slug: "kabel",
    definition:
      "Een verzameling van geleiders die samen een elektrisch signaal of stroom transporteren.",
    category: "Installatie",
    relatedTerms: [
      { term: "Kabelgoot", slug: "kabelgoot" },
      { term: "Draad", slug: "draad" },
    ],
  },
  {
    term: "Installatiedraad",
    slug: "installatiedraad",
    definition:
      "Een draad die specifiek is ontworpen voor gebruik in elektrische installaties.",
    category: "Installatie",
    relatedTerms: [
      { term: "Kabel", slug: "kabel" },
      { term: "Draad", slug: "draad" },
    ],
  },
  {
    term: "Draad",
    slug: "draad",
    definition:
      "Een dunne geleider die gebruikt wordt in elektrische installaties om stroom te transporteren.",
    category: "Installatie",
    relatedTerms: [
      { term: "Kabel", slug: "kabel" },
      { term: "Installatiedraad", slug: "installatiedraad" },
    ],
  },
];

// Sort the terms by 'term' alphabetically
allTerms.sort((a, b) => a.term.localeCompare(b.term));
